import { defaultDescription } from "./constants";
import { CsvDescription, CsvWriteDescription } from "./types";
import { CsvChunkParser } from "./parser";
import { arrayToCsvLine } from "./utils";


export class CsvArrayStream extends TransformStream<Uint8Array, string[]> {

	private parser: CsvChunkParser;
	private decoder: TextDecoder;

	constructor(desc?: Partial<CsvDescription>) {

		super({
			transform: (chunk, controller) => {
				const lines = this.parser.parseChunk(this.decoder.decode(chunk));
				if (lines.length > 0) {
					lines.forEach(line => controller.enqueue(line));
				}
			},
			flush: (controller) => {
				if (!this.parser.eol) controller.enqueue(this.parser.incompleteLine);
				controller.terminate();
			},
		});

		this.parser = new CsvChunkParser(desc);
		this.decoder = new TextDecoder();
	}

}

export class CsvByteStream extends TransformStream<unknown[], Uint8Array> {

	private encoder: TextEncoder;
	private desc: CsvWriteDescription;

	constructor(desc?: Partial<CsvWriteDescription>) {
		super({
			transform: (chunk, controller) => {
				controller.enqueue(this.encoder.encode(arrayToCsvLine(chunk, this.desc)));
			},
			flush: (controller) => {
				controller.terminate();
			},
		});

		this.desc = Object.assign({}, defaultDescription, desc);
		this.encoder = new TextEncoder();
	}

}
